export class CashbookDto {
    cashbookId?: number;
    empId: number;
    amount: string;
    activityDate: Date;
    status: boolean;
    createdAt : Date | any;
    createdUser : number;
    updatedAt : Date | any;
    updatedUser : number;
    versionFlag : number;
  }
  
  export const CashbookDtoDefault : CashbookDto = {
    cashbookId: 0,
    empId: 1,
    amount: "",
    activityDate: new Date(),
    status: true,
    createdAt : new Date() ,
    createdUser : 0,
    updatedAt : new Date() ,
    updatedUser : 0,
    versionFlag : 0
  };
  
  